import { render, staticRenderFns } from "./TicketMessageActions.vue?vue&type=template&id=03064405&scoped=true&"
import script from "./TicketMessageActions.vue?vue&type=script&lang=ts&"
export * from "./TicketMessageActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03064405",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03064405')) {
      api.createRecord('03064405', component.options)
    } else {
      api.reload('03064405', component.options)
    }
    module.hot.accept("./TicketMessageActions.vue?vue&type=template&id=03064405&scoped=true&", function () {
      api.rerender('03064405', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketMessageActions.vue"
export default component.exports